import * as yup from "yup";

import type { TFunction } from "i18next";

/** Único campo validado por este schema; el resto del registro llega vía `setValue`. */
export interface MonthlyHourValues {
  hours: number;
}

/**
 * Construye el schema de validación para actualizar un registro mensual de horas.
 * Solo valida `hours` porque los demás campos se inyectan vía setValue desde el
 * objeto seleccionado en la tabla; no se ingresan manualmente.
 */
export const buildMonthlyHourSchema = (t: TFunction): yup.ObjectSchema<MonthlyHourValues> =>
  yup.object().shape({
    hours: yup.number().required(t("isRequired")),
  }).required();
